import React from 'react';
import {
  Button,
  Container,
  Header,
  Icon,
  Menu,
  Segment
} from 'semantic-ui-react';

function App() {
  return (
    <div>
      <style type="text/css">
        {`.ui.inverted.vertical.segment {
        height: 100vh;
      }
      .ui.inverted.vertical.segment h1.header.item {
        font-size: 2em;
      }
      .ui.inverted.vertical.segment a.item {
        font-size: 1.2em;
      }
      .ui.inverted.vertical.segment .ui.text.container {
        height: 300px;
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        margin: auto;
      }
      .ui.inverted.vertical.segment .ui.text.container h1.header {
        font-size: 3em;
        margin-bottom: 50px;
      }
      .ui.inverted.vertical.segment .ui.text.container p {
        font-size: 1.6em;
        line-height: 1.6;
      }
      .ui.inverted.vertical.segment .ui.footer.segment {
        height: 80px;
        width: 100%;
        position: absolute;
        bottom: 0;
        font-size: 1.2em;
        color: gray;
      }
      .ui.inverted.vertical.segment .ui.footer.segment a {
        color: white;
      }
      `}
      </style>
      <Segment vertical inverted textAlign="center">
        <Container>
          <Menu inverted borderless size="massive">
            <Menu.Item as="h1" header>
              Ascend
            </Menu.Item>
          </Menu>
          <Container text>
            <Header as="h1" inverted>
              Fly Higher
            </Header>
            <Button
              as="a"
              animated
              size="massive"
              color="blue"
              href={`https://drive.google.com/uc?export=download&id=1gyb8G867WjEyE7ZBkgEkp3sOhKRLNR-n`}
            >
              <Button.Content visible>Download for Android</Button.Content>
              <Button.Content hidden>
                <Icon name="download" />
              </Button.Content>
            </Button>
          </Container>
        </Container>
        <Segment inverted vertical className="footer">
          &copy; 2019 <a href="https://techkunja.com.np">Tech Kunja</a> All
          Rights Reserved
        </Segment>
      </Segment>
    </div>
  );
}

export default App;
